<template>
  <div>
    <div style="position: relative">
      <vs-row vs-w="12" class="mb-4">
        <vs-col class="p-0">
          <vs-row vs-w="12" class="mb-4 align-items-center" vs-align="center">
            <vs-col
              vs-type="flex"
              vs-align="center"
              class="p-0"
              vs-w="7"
              vs-sm="8"
              vs-xs="12"
            >
              <h3
                class="d-inline-block align-self-center uppercase"
                :class="{ h2: !nested, h3: nested }"
              >
                {{ title || 'Payouts!' }}
              </h3>
              <router-link :to="viewMoreUrl" class="d-inline-block">
                <vs-button
                  v-if="viewMore"
                  color="primary"
                  type="border"
                  size="small"
                  class="d-inline-block ml-5 vertical-align-top"
                  >View more</vs-button
                >
              </router-link>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-align="center"
              class="p-0 xs-hide"
              vs-w="5"
              vs-sm="4"
            >
              <div class="mx-auto mr-0" v-if="exportOptions">
                <vs-button
                  @click="activeExportPrompt = true"
                  color="primary"
                  type="border"
                  class="xs-hide"
                  >Export options</vs-button
                >
                <vs-prompt
                  @vs-cancel="logAction('cancel')"
                  @vs-accept="doExport"
                  @vs-close="logAction('close')"
                  vs-accept-text="Export"
                  vs-cancel-text="Cancel"
                  vs-title="Export options"
                  color="primary"
                  :vs-active.sync="activeExportPrompt"
                >
                  <div class="prompt export-prompt">
                    <p>No options yet.</p>
                  </div>
                </vs-prompt>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>

      <vs-row vs-w="12" class="dashboard-panel">
        <vs-col class="p-0">
          <vs-table
            v-model="selected"
            pagination
            :max-items="
              maxItemsPerPage
                ? maxItemsPerPage
                : itemsPerPage
                ? itemsPerPage.value
                : 10
            "
            :data="filteredPayouts"
            @selected="handleSelected"
          >
            <template slot="thead">
              <vs-th class="h6" sort-key="date">Date</vs-th>
              <vs-th class="h6" sort-key="status">Status</vs-th>
              <vs-th class="h6 xs-hide">Payout Reference</vs-th>
              <vs-th class="h6 col-text-right"
                >Amount ({{ localCurrency }})</vs-th
              >
              <vs-th class="h6 col-text-right">Updated</vs-th>
              <vs-th class="h6 col-text-right">Download</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :data="tr"
                :key="indextr"
                v-for="(tr, indextr) in data"
                class="hoverFlat"
              >
                <vs-td
                  :data="data[indextr].payout_date.split('T')[0]"
                  class="no-line-wrap"
                >
                  <div class="xs-hide">
                    {{
                      data[indextr].payout_date
                        ? data[indextr].payout_date.split('T')[0]
                        : ' - '
                    }}
                  </div>
                  <div class="xs-show" style="display: none">
                    {{
                      data[indextr].payout_date
                        ? data[indextr].payout_date.split('T')[0]
                        : ' - '
                    }}
                  </div>
                </vs-td>

                <vs-td :data="data[indextr].status" class="no-line-wrap">
                  <div class="xs-hide">{{ data[indextr].status }}</div>
                  <div class="xs-show" style="display: none">
                    {{ data[indextr].status }}
                  </div>
                </vs-td>

                <vs-td :data="data[indextr].payout_reference" class="xs-hide">{{
                  data[indextr].payout_reference || ' - '
                }}</vs-td>

                <vs-td :data="data[indextr].net_amount" class="text-right">{{
                  formatFiatPrice(data[indextr].net_amount)
                }}</vs-td>

                <vs-td
                  :data="data[indextr].status_date.split('T')[0]"
                  class="no-line-wrap col-text-right"
                >
                  <div class="xs-hide">
                    {{
                      data[indextr].status_date
                        ? data[indextr].status_date.split('T')[0]
                        : ' - '
                    }}
                  </div>
                  <div class="xs-show" style="display: none">
                    {{
                      data[indextr].status_date
                        ? data[indextr].status_date.split('T')[0]
                        : ' - '
                    }}
                  </div>
                </vs-td>

                <vs-td :data="data[indextr].net_amount" class="text-right">
                  <vs-button
                    type="border"
                    color="lightgrey"
                    icon="picture_as_pdf"
                    text-color="red"
                    class="float-right dwnloadBtn"
                    >PDF</vs-button
                  >
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-col>
      </vs-row>
      <vs-row vs-w="12" v-if="!hidePager">
        <vs-col class="p-0">
          <div
            class="items-per-page-container"
            v-if="filteredPayouts && filteredPayouts.length"
          >
            Items per page:
            <v-select
              :options="itemsPerPageOptions"
              :clearable="false"
              v-model="itemsPerPage"
              class="bg-white items-per-page-select"
            ></v-select>
          </div>
        </vs-col>
      </vs-row>
    </div>

    <!-- <triplea-payout-popup
     :payout="selected"
     :debug-payout="debugPayouts"
     :local-currency="localCurrency"
     :display-counter="popupDisplayCounter"
    >-->
    <!-- </triplea-payout-popup> -->

    <pre v-if="debugSelected">{{ selected }}</pre>
  </div>
</template>

<script>
import vSelect from 'vue-select';
// import {Parser} from 'json2csv';
// import {saveAs} from 'file-saver';

import TripleaTxPopup from '../triplea-tx-popup/TripleaTxPopup';

export default {
  components: {
    'v-select': vSelect,
    TripleaTxPopup,
  },
  props: {
    payouts: Array,
    title: String,
    debugPayouts: Boolean,
    debugSelected: Boolean,
    localCurrency: String,
    maxItemsPerPage: {
      type: Number,
      default: null,
    },
    hidePager: {
      type: Boolean,
      default: false,
    },
    viewMore: {
      type: Boolean,
      default: false,
    },
    viewMoreUrl: {
      type: String,
      default: '',
    },
    exportOptions: {
      type: Boolean,
      default: true,
    },
    nested: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeCSVPrompt: false,
      activeExportPrompt: false,
      selected: null,
      itemsPerPageOptions: [
        {
          label: '5',
          value: 5,
        },
        {
          label: '10',
          value: 10,
        },
        {
          label: '15',
          value: 15,
        },
        {
          label: '20',
          value: 20,
        },
        {
          label: '40',
          value: 40,
        },
      ],
      itemsPerPage: null,
      txIdForPopup: null,
      // When a same row is clicked after already being selected,
      // we increment this number to trigger re-displaying of popup.
      popupDisplayCounter: 0,
    };
  },
  mounted() {
    this.itemsPerPage = this.itemsPerPageOptions[1];
  },
  computed: {
    filteredPayouts() {
      return this.filterTx(this.payouts).sort(function (a, b) {
        return b.blocktime - a.blocktime;
      });
    },
  },
  methods: {
    doExport() {
      console.warn('not implemented yet');
    },
    logAction(text) {
      console.warn('logAction(): ' + text);
    },
    formatTxTableTime(timeString) {
      return timeString.split(' ')[0];
    },
    // eslint-disable-next-line no-unused-vars
    handleSelected(tr) {
      this.popupDisplayCounter += 1;
      // this.$vs.notify({
      //   title:`Selected ${tr.username}`,
      //   text:`Email: ${tr.email}`
      // })
    },
  },
};
</script>

<style>
.tr-expand td .content-tr-expand,
.tr-expand td .tr-expand--close {
  justify-content: normal;
}

.contain-expand-tx {
  width: 100%;
}

tr.tr-expand {
  box-shadow: inset rgba(0, 0, 0, 0.15) 0px 4px 6px;
}

.lh-30 {
  line-height: 30px;
}

.items-per-page-container {
  position: absolute;
  bottom: 10px;
  zoom: 0.85;
}

@media (max-width: 800px) {
  .items-per-page-container {
    position: relative;
    zoom: 0.85;
    margin-left: auto;
    display: block;
    width: fit-content;
    margin-top: 20px;
  }
}

.items-per-page-select {
  width: 100px;
  display: inline-block;
}

.prompt {
  padding: 10px 10px 0;
}

.col-text-right {
  text-align: right;
}

.col-text-right div {
  display: inline-block;
}

.vertical-align-top {
  vertical-align: top;
}

.vs-table--tbody-table tr {
  border-top: 1px solid lightgray;
  font-size: 16px;
}

.vs-table--tbody-table thead tr {
  border: none;
  background: unset;
}

.vs-table--tbody-table .tr-values.hoverFlat {
  transition: none;
}

.vs-table--tbody-table
  .tr-values.hoverFlat:not(.activeEdit):not(.is-expand):hover {
  opacity: 0.8;
  background: #eee;
  transition: none;
}

.dwnloadBtn {
  margin: 2px;
  padding: 1px;
  width: 60px;
  height: 30px;
  font-size: 10px;
}
</style>
